import type { AuthConfig } from "../data/types/auth";
import { apiConfigStorage } from "../services/auth/api-config-storage/api-config-storage";
import { envConfig } from "./env";

const DEFAULT_SCOPE = "https://auth.trackman.com/dr/facility";

/**
 * Get authentication configuration dynamically from storage + env vars
 * URLs come from build-time env vars; credentials come from storage
 */
export async function getAuthConfig(): Promise<AuthConfig | null> {
  const apiConfig = await apiConfigStorage.getConfig();

  if (!apiConfig) {
    return null;
  }

  return {
    issuerBaseURL: envConfig.authBaseUrl,
    clientId: apiConfig.clientId,
    clientSecret: apiConfig.clientSecret,
    scope: apiConfig.scope || DEFAULT_SCOPE,
  };
}
